var mp = mp || {};


// Slider - Quotes
//-----------------------------------------------------------------
mp.sliderQuotes = function() {
    var $slider = $('.slider--quotes');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: false,
        dots: false,
        speed: 1000,
        autoplaySpeed: 6000,
        autoplay: true,
        pauseOnFocus: false,
        pauseOnHover: true,
        infinite: true,
        slidesToShow: 1,
    });
}




// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function() {
    var $slider = $('.slider--hero');

    if (!$slider.length) {
        return;
    }

    $slider.on('init', function(event, slick) {
        $(this).find(".slick-active").addClass("slick-animate");
    });
    
    
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
        $currentSlide = $slider.find(".slick-slide").eq(currentSlide);
        
        window.setTimeout(function() {
            $currentSlide.removeClass("slick-animate");
        }, 1200);

        $nextSlide = $slider.find(".slick-slide").eq(nextSlide);
        $nextSlide.addClass("slick-animate");
    });

    $slider.slick({
        arrows: false,
        dots: false,
        speed: 1200,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
    });
}


// Slider - Project List
//-----------------------------------------------------------------
mp.sliderProjectList = function() {
    var $slider = $('.slider--projects');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: true,
        dots: false,
        speed: 1000,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '8%',
        prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-prev"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="icon icon-next"></i></button>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: false,
                    dots: true,
                }
            },
        ]
    });
}


// Slider - Project Gallery
//-----------------------------------------------------------------
mp.sliderProjectGallery = function() {
    var $slider = $('.slider--project-gallery');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        arrows: true,
        dots: false,
        speed: 1000,
        fade: true,
        autoplay: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        slidesToShow: 1,
        prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-prev"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="icon icon-next"></i></button>'
    });
}



$(document).ready(function (){
    mp.sliderQuotes();
});